import { useTranslation } from "react-i18next";

import "../styles.css";

const RegisterInvalidLink = () => {
  const { t } = useTranslation();

  return (
    <div className="register full-width flex flex-col gap-400 text-center">
      <div className="flex flex-col gap-200">
        <h2 className="register__title header-m-medium">
          {t("auth.labels.invalidLinkTitle")}
        </h2>

        <p className="register__description body-m-regular">
          {t("auth.labels.invalidLinkDescription")}
        </p>
      </div>
    </div>
  );
};

export default RegisterInvalidLink;
